<template lang="pug">
    layout.contentTransparent

        // Main title
        title-component(
            slot="title"
            type="h2"
            :title="$t('users.templateCreate.title')"
        )


        v-container.py-0.px-0(fluid grid-list-lg)
            v-layout(raw wrap)
                v-flex(xs12 md3)
                    div.block.conatinerPadder

                        // Form title
                        title-component(
                            type="h4"
                            :title="$t('users.create.defaultColumnsSubtitle')"
                        )

                        // Default fields
                        accordion-component.pt-0(:items="defaultFields")

                v-flex(xs12 md9)
                    div.block
                        v-container.pt-4.hidden-xs-only(fluid grid-list-lg)
                            v-layout(raw wrap)
                                v-flex(xs12 sm4)

                                    // Form title (title)
                                    title-component(
                                        type="h4"
                                        :title="$t('users.create.titleSubtitle')"
                                    )

                                v-flex(xs12 sm4)

                                    // Form title (type)
                                    title-component(
                                        type="h4"
                                        :title="$t('users.create.typeSubtitle')"
                                    )

                                v-flex(xs12 sm3 offset-sm1)

                                    // Form title (required)
                                    title-component(
                                        type="h4"
                                        :title="$t('users.create.requiredSubtitle')"
                                    )
                        // Create fields form
                        create-form.createForm
</template>

<script>
    import Layout from '../../Layout/Layout';
    import CreateForm from './CreateForm';
    import Title from '~components/Title';
    import Accordion from '~components/Accordion';
    import { mapGetters } from 'vuex';
    import dropRight from 'lodash/dropRight';

    export default {
        components: {
            Layout,
            CreateForm,
            TitleComponent: Title,
            AccordionComponent: Accordion
        },
        computed: {
            ...mapGetters('auth', ['showDepartment']),
            defaultFields() {
                const fields = this.$t('users.create.defaultFields');

                return this.showDepartment ? fields : dropRight(fields);
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../../assets/style/_variables.styl'

    .block
        background-color: $theme.cardBg
        height: 100%
        box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);

    .createForm
        height: calc(100% - 55px)
        display: flex
        flex-direction: column
        justify-content: space-between
</style>
